export const MigrationMappingSource = {
  None: 'None',
  Migration: 'Migration',
  V1Sync: 'V1Sync',
} as const;

export interface MigrationReadinessReport {
  AccountId: number
  AccountName: string | null
  V1SyncedFacilityId: number | null
  V1SyncTenantId: number | null
  MappedFacilityId: number | null
  MappingSource: string | null
  AutomaticLinkingEnabled: boolean | null
  EligibleUserCount: number
  UnlinkedUserCount: number
  UnlinkedUserSummary: string
  Status: string | null
  CustomerType: string | null
  CreateDate: string | null
  LoginType: string | null
  TimezoneId: number | null
  CallerId: string | null
  ThrottleSetting: number | null
  RepeatMessage: boolean | null
  TtsRate: number | null
  ApiEnabled: boolean | null
  SendPostEventReport: boolean | null
  PostEventEmailRecipients: string | null
  SalesForceAccountId: string | null
  IsNotForProfit: boolean | null
  CommunityName: string | null
  SeniorsAlias: string | null
  StaffAlias: string | null
  FamilyAlias: string | null
  UniquePhoneNumber: boolean
  TransferToNumberCount: number
  TransferToNumbers: string[]
  SyncedResidents: number
  UnsyncedResidents: number
  SyncedStaff: number
  UnsyncedStaff: number
  SyncedFamily: number
  UnsyncedFamily: number
  FutureScheduledBroadcastsCount: number
  BroadcastTemplateCount: number
  MarketingTemplateCount: number
  LibraryContentCount: number
  TotalAutomaticEventsCount: number
  ActiveAutomaticEventsCount: number
  SmsInboxEnabled: boolean
  SmsAutoRepliesCount: number
  VirtualMeetingsCount: number
  AppointmentRemindersCount: number
  WellnessChecksCount: number
  InactivePeriodCount: number
  DoNotCallBetweenCount: number
  CustomFieldCount: number
  CustomFields: string[]
  ApiKeyCount: number
  ApiKeyUsernames: string[]
  LifeDateFieldCount: number
  LifeDateFields: string[]
  ComplianceDateFieldCount: number
  ComplianceDateFields: string[]
  PhoneSimpleSurveyCount: number
  ActivityAttendanceCount: number
  AppointmentReminderTemplateCount: number
  AccushieldTemplateCount: number
  Feedback360SurveyCount: number
  EnterpriseFeedback360SurveyCount: number
  EnterpriseReportingEnabled: boolean
  BroadcastGreetingFarewellEnabled: boolean
  OnDemandGreetingFarewellEnabled: boolean
  SeniorIntegrationBanner: string | null
  StaffIntegrationBanner: string | null
  FamilyIntegrationBanner: string | null
  DailyScheduledReportCount: number
  DischargedPatientRecordCount: number
  OnDemandUsageCount: number
  ReplyForwardingCount: number
  EmailSenderDomains: string[]
  RegisteredPhoneNumbers: string[]
}
